/* eslint-disable no-unused-vars */

export enum synchronizationConstant {
  CONNECTIONS_FETCH_REQUESTED = 'CONNECTIONS_FETCH_REQUESTED',
  CONNECTIONS_FETCH_SUCCEEDED = 'CONNECTIONS_FETCH_SUCCEEDED',
  PROJECTS_FETCH_REQUESTED = 'PROJECTS_FETCH_REQUESTED',
  PROJECTS_FETCH_SUCCEEDED = 'PROJECTS_FETCH_SUCCEEDED',
  PROJECTS_FETCH_LOADING = 'PROJECTS_FETCH_LOADING',
  DOCUMENT_FETCH_REQUESTED = 'DOCUMENT_FETCH_REQUESTED',
  DOCUMENT_FETCH_SUCCEEDED = 'DOCUMENT_FETCH_SUCCEEDED',
  DOCUMENT_FETCH_LOADING = 'DOCUMENT_FETCH_LOADING',
  UPDATE_CURRENT_CONNECTION = 'UPDATE_CURRENT_CONNECTION',
  UPDATE_CURRENT_PROJECT = 'UPDATE_CURRENT_PROJECT',
  UPDATE_CURRENT_FOLDER = 'UPDATE_CURRENT_FOLDER',
  UPDATE_CURRENT_SELECTED_FOLDERS = 'UPDATE_CURRENT_SELECTED_FOLDERS',
  SYNC_DOCUMENT_REQUESTED = 'SYNC_DOCUMENT_REQUESTED',
  UPDATE_SYNC_DOCUMENT_STATUS = 'UPDATE_SYNC_DOCUMENT_STATUS',
  SYNC_DOCUMENT_PROCESSING = 'SYNC_DOCUMENT_PROCESSING',
  RESET_PROJECT = 'RESET_PROJECT',
  RESET_SYNC_PROJECT = 'RESET_CONNECTION',
  UPDATE_SELECTED_CONNECTION = 'UPDATE_SELECTED_CONNECTION',
  UP_TO_PARENT = 'UP_TO_PARENT',
}
